setLiveAccessSessionDetailsError